import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { token } from '@atlaskit/tokens';
import { Text } from '@atlaskit/primitives';
import ClockIcon from '@atlaskit/icon/core/clock';

import {
	PreviewPanel,
	PreviewPanelHeader,
	PreviewPanelTitle,
	PreviewPanelBody,
} from '@atlassian/preview-panel';

const i18n = defineMessages({
	title: {
		id: 'content-history-new.panel.title',
		defaultMessage: 'Version history',
		description: 'The title displayed in the version history panel',
	},
});

export const ContentHistoryPanel = () => {
	const { formatMessage } = useIntl();

	return (
		<PreviewPanel testId="content-history-panel">
			<PreviewPanelHeader>
				<PreviewPanelTitle
					title={formatMessage(i18n.title)}
					color="color.text.subtle"
					icon={<ClockIcon label="" color={token('color.icon.subtle')} />}
				/>
			</PreviewPanelHeader>
			<PreviewPanelBody>
				<Text> Some cool components I will add in the future</Text>
			</PreviewPanelBody>
		</PreviewPanel>
	);
};
